import axios from '@axios'

export default {
  state: {
    infoWorkspace: '',
    reviewsPagination: {},
    reviews: [],
    reviewsSettingsPagination: {
      page: 1,
      size: 10,
      order: 'id',
      query: '',
    },
  },
  getters: {
    getInfoWorkspace(state) {
      return state.infoWorkspace
    },
    getReviewsPagination(state) {
      return state.reviewsPagination
    },
    getReviews(state) {
      return state.reviews
    },
    getReviewsSettingsPagination(state) {
      return state.reviewsSettingsPagination
    },
  },
  mutations: {
    UPDATE_INFO_WORKSPACE(state, data) {
      state.infoWorkspace = data
    },
    UPDATE_REVIEWS_PAGINATION(state, data) {
      state.reviewsPagination = data
    },
    UPDATE_REVIEWS(state, data) {
      state.reviews = data
    },
    UPDATE_REVIEWS_SETTINGS_PAGINATION(state, { key, value }) {
      state.reviewsSettingsPagination[key] = value
    },
  },
  actions: {
    fetchLogoOrgAndSpecialist(context, workspace) {
      return new Promise((resolve, reject) => {
        axios.get(`/storefront/workspaces/review/info/${workspace}`)
          .then(response => {
            context.commit('UPDATE_INFO_WORKSPACE', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    createReview(context, formData) {
      return new Promise((resolve, reject) => {
        axios.post(`/storefront/workspaces/review/create/${formData.get('workspace')}`, formData)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchReviews(context, formData) {
      return new Promise((resolve, reject) => {
        axios.get(`/storefront/workspaces/reviews/${formData.get('workspace')}?order=id&page=1&page_size=100`)
          .then(response => {
            context.commit('UPDATE_REVIEWS_PAGINATION', response.data.pagination)
            context.commit('UPDATE_REVIEWS', response.data.result)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
